import { publicHttp } from "~/config/axios";

export type AppVersionPolicyUpdateType = "none" | "recommend" | "force";
export type AppVersionPolicyPlatform = "android" | "ios";
export type AppVersionPolicyAppType = "customer" | "business";

export interface AppVersionPolicy {
  policySeq?: number;
  appType: AppVersionPolicyAppType;
  platform: AppVersionPolicyPlatform;
  currentVersion?: string | null;
  currentBuild?: number | null;
  minVersion?: string | null;
  minBuild?: number | null;
  latestVersion?: string | null;
  latestBuild?: number | null;
  updateType: AppVersionPolicyUpdateType;
  updateRequired?: boolean;
  forceUpdate?: boolean;
  recommendUpdate?: boolean;
  storeUrl?: string | null;
  fallbackStoreUrl?: string | null;
  title?: string | null;
  message?: string | null;
  enabled?: boolean;
}

export interface AppVersionPolicyRequest {
  appType: AppVersionPolicyAppType;
  platform: AppVersionPolicyPlatform;
  version?: string | null;
  build?: number | null;
}

interface ApiResponse<T> {
  data: T;
}

export const getAppVersionPolicy = async (
  params: AppVersionPolicyRequest,
): Promise<AppVersionPolicy> => {
  const { data } = await publicHttp.get<ApiResponse<AppVersionPolicy>>(
    "/app/version-policy",
    {
      params,
    },
  );

  return data.data;
};
